import { SafariObjectId } from '../base-object/models/app/safari-object-base';

export class ObjectHistory {
  id: SafariObjectId;
  history: any; // we'll change this when we know for sure if we're keeping current audit object structure
}
